import React from "react";
import AboutScene from "./about/AboutScene";
import "../styles/AboutSection.css";
import "../styles/AboutScene.css";

export default function AboutSection() {
  return <AboutScene />;
}
